﻿import { tabulator } from './tabulator.utils';

const mediaModalButtons = document.querySelectorAll('[data-media-modal]');

const mediaModal = document.querySelector('#mediaModal')
const mediaDetail = mediaModal.querySelector('#media-detail');
const sendSelectedBtn = mediaModal.querySelector('#sendSelectedBtn');

let table;
let mediaOptions = {
  tableInitUrl: '/media/images/list/?handler=TabulatorList',
  imageDetailsUrl: '/media/images/details/?handler=Partial'
};

const tableOptions = {
  initialSort: [{ column: 'createdOn', dir: 'desc' }],
  persistence: {
	sort: false,
	filter: false,
	headerFilter: false,
	group: false,
	page: false,
	columns: false,
  },
  paginationSize: 5,
  paginationSizeSelector: [5, 10, 20],
  columns: [
	{
	  formatter: 'rowSelection', titleFormatter: 'rowSelection',
	  hozAlign: 'center', headerHozAlign: 'center', headerSort: false,
	  width: 40,
	},
	{
	  title: '', field: 'createdOn',
	  headerFilter: false, visible: false
	},
	{
	  title: '', field: 'sourceUrl',
	  headerFilter: false, headerSort: false, width: 60,
	  formatter: 'image', formatterParams: { height:'50px'}
	},
	{
	  title: 'File', field: 'originalFilename',
	  headerFilter: 'input', headerSort: false,
	},
	{
	  title: 'Nome', field: 'title',
	  headerFilter: 'input', headerSort: false,
	},
	{
	  title: '', field: 'sizedUrls',
	  hozAlign: 'center', headerSort: false,
	  formatter: tabulator.fileUrls
	},
	{
	  title: '', field: 'id', hozAlign: 'center', width: 10, responsive: 0,
	  headerSort: false,
	  formatter: function (cell, formatterParams, onRendered) {
		return `<button type="button" class="btn btn-action btn-yellow" onclick="app.getImageDetails('${cell.getValue()}')">
		  <i class="i-carbon-search" title="Dettagli"></i>
		</button>`;
	  }
	}
  ]
};

mediaModalButtons.forEach((btn) => {
  btn.addEventListener('click', function () {
	let options = JSON.parse(btn.dataset.mediaModal);
	mediaOptions = {
	  ...options,
	  ...mediaOptions,
	};
  });
});

mediaModal.addEventListener('modal.show', function (event) {
  tableOptions.ajaxURL = mediaOptions.tableInitUrl;
  tableOptions.selectable = mediaOptions.selectable ? 'highlight' : false;
  tableOptions.columns[0].visible = mediaOptions.selectable;

  table = app.tabulator.init('#media-modal-table', mediaOptions.token, tableOptions);
  table.on("rowSelectionChanged", function (data, rows) {
	let selectedItems = table.getSelectedData();
	if (selectedItems.length == 0) {
	  sendSelectedBtn.setAttribute('disabled', 'disabled');
	} else {
	  sendSelectedBtn.removeAttribute('disabled');
	}
  });
});

mediaModal.addEventListener('modal.hide', function (event) {
  table.destroy();
  mediaDetail.innerHTML = `<h5 class="text-center bg-stone-600 text-stone-100">Seleziona un'immagine per vedere i dettagli</h5>`;
});

export function getImageDetails(id) {
  let url = `${mediaOptions.imageDetailsUrl}&id=${id}`;
  fetch(url)
	.then(response => response.text())
	.then(html => {
	  mediaDetail.innerHTML = html;
	  app.initCollapses();
	})
}

export function getSelectedImages() {
  let selectedItems = table.getSelectedData();
  if (selectedItems.length > 0) {
	let selectedEvent = new CustomEvent('media.selected', { bubble: true, detail: { items: selectedItems } });
	document.dispatchEvent(selectedEvent);
	app.toggleModal(mediaModal);
  }
}

export function reloadMediaModal() {
  app.toggleModal(mediaModal);
  app.toggleModal(mediaModal);
}